import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ProductForm from "./ProductForm";
import { useProducts } from "../useHook";
import Loader from "../../../Utils/loader";

function ProductFormPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const productId =
    location.state?.id ||
    new URLSearchParams(location.search).get("id") ||
    null;
  const returnUrl = location.state?.returnUrl || "/products";

  const { getCategories, getBrands, addProduct } = useProducts();
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadInitialData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          getCategories(setCategories),
          getBrands(setBrands),
        ]);
      } catch (error) {
        console.error("Error fetching product form data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadInitialData();
  }, []);

  const goBack = () => {
    navigate(returnUrl);
  };

  const handleAddProduct = async (formData) => {
    try {
      const response = await addProduct(formData);

      if (response) {
        Swal.fire({
          title: "Success!",
          text: "Product has been added successfully.",
          icon: "success",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
          toast: false,
          position: "center",
        });
      }

      return response;
    } catch (error) {
      console.error("Error adding product:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to add product. Please try again.",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
      throw error;
    }
  };

  if (isLoading) {
    return (
      <Loader
        message={
          productId ? "Loading product form..." : "Loading add product form..."
        }
      />
    );
  }

  return (
    <ProductForm
      categories={categories}
      brands={brands}
      showModal={true}
      setShowModal={(open) => {
        if (!open) goBack();
      }}
      addProduct={handleAddProduct}
      productToEdit={null}
      productId={productId}
      onSuccess={goBack}
    />
  );
}

export default ProductFormPage;
